// Pass 60: planned leave on the duty calendar. Shared by the admin and
// staff duty pages. Admin rows use the sheet's column names; staff rows
// come back trimmed to name and days. Both reduce to {name, start, end}.

export function normaliseLeave(rows) {
  return (rows || []).map((r) => ({
    id: r.ID || r.id || "",
    name: r.Member_Name || r.member_name || "",
    start: r.Start_Date || r.start_date || "",
    end: r.End_Date || r.end_date || "",
    mine: Boolean(r.mine),
  }));
}

// {"YYYY-MM-DD": ["Name", ...]} for every day inside [from, to].
export function awayByDay(leave, from, to) {
  const out = {};
  for (const l of leave) {
    let d = l.start > from ? l.start : from;
    const last = l.end < to ? l.end : to;
    while (d <= last) {
      (out[d] = out[d] || []).push(l.name);
      d = nextDay(d);
    }
  }
  for (const k of Object.keys(out)) out[k] = Array.from(new Set(out[k])).sort();
  return out;
}

export function nextDay(iso) {
  const [y, m, d] = iso.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d + 1));
  return dt.toISOString().slice(0, 10);
}

export function dayLabel(iso) {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d).toLocaleDateString("en-GB", { weekday: "short", day: "2-digit", month: "short", year: "numeric" });
}

export function spanLabel(start, end) {
  return start === end ? dayLabel(start) : `${dayLabel(start)} to ${dayLabel(end)}`;
}

export function monthBounds(year, month) {
  const mm = String(month + 1).padStart(2, "0");
  const last = new Date(year, month + 1, 0).getDate();
  return { from: `${year}-${mm}-01`, to: `${year}-${mm}-${String(last).padStart(2, "0")}` };
}

// Sits under the day number, in the empty top half of the cell, rather
// than squeezed under the duty pill. Up to three names; the rest roll
// up into "+N more" with the full list on hover. On phones the cell is
// a row, and this sits under the weekday on the left.
const MAX_NAMES = 3;

export function OnLeaveList({ names, testId }) {
  if (!names || !names.length) return null;
  const shown = names.slice(0, MAX_NAMES);
  const extra = names.length - shown.length;
  return (
    <div className="scw-duty-leave" title={`On leave: ${names.join(", ")}`} data-testid={testId}
      style={{ marginTop: 8, borderLeft: "2px solid #B8860B", paddingLeft: 7 }}>
      <div style={{ fontSize: 9, letterSpacing: "0.16em", textTransform: "uppercase", color: "#8a6d3b", marginBottom: 2 }}>
        On leave
      </div>
      {shown.map((n) => (
        <div key={n} style={{ fontSize: 12, lineHeight: 1.35, color: "#3D3D3D", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>{n}</div>
      ))}
      {extra > 0 && <div style={{ fontSize: 11, color: "#8a6d3b" }}>+{extra} more</div>}
    </div>
  );
}
